import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../../../common/helpers/helpers";

const GnomadUrl = ({ variantResult, gnomadType, refGenome, version }) => {
  let exacUrl;
  let ov;
  const dataTipText = `The gnomAD browser contains the combined result from exomes and whole genomes.`;
  if (gnomadType === "exomes") {
    ov = variantResult?.gnomad_exomes[0].original_variant;
  }
  if (gnomadType === "genomes") {
    ov = variantResult.gnomad_genomes[0].original_variant;
  }
  let dataSet = "gnomad_r4";

  switch (true) {
    case version.startsWith("2.1"):
      dataSet = "gnomad_r2_1";
      break;
    case version.startsWith("3"):
      dataSet = "gnomad_r3";
      break;
    default:
      break;
  }

  if (refGenome === "hg19") {
    if (ov) {
      exacUrl = `http://gnomad.broadinstitute.org/variant/${ov}?dataset=${dataSet}`;
    } else if (
      variantResult.ref &&
      variantResult.alt &&
      variantResult.ref.length === 1 &&
      variantResult.alt.length === 1
    ) {
      exacUrl = `http://gnomad.broadinstitute.org/variant/${variantResult.chromosome.replace(
        "chr",
        ""
      )}-${variantResult.pos}-${variantResult.ref}-${
        variantResult.alt
      }?dataset=${dataSet}`;
    }
  } else {
    if (dataSet === "gnomad_r2_1" && refGenome === "hg38") {
      return (
        <span className="varsome-right">
          <small className="tw-mr-4" data-testid="warning-message">
            <i className="varsome-icons icon-info" data-tooltip={dataTipText} />
            {` Exomes 2.1.1 for hg38 is not available on gnomad website, please refer to the hg19 version of the variant.`}
          </small>
        </span>
      );
    }
    if (ov) {
      exacUrl = `http://gnomad.broadinstitute.org/variant/${ov}?dataset=${dataSet}`;
    } else if (
      variantResult.ref &&
      variantResult.alt &&
      variantResult.ref.length === 1 &&
      variantResult.alt.length === 1
    ) {
      exacUrl = `http://gnomad.broadinstitute.org/variant/${variantResult.chromosome.replace(
        "chr",
        ""
      )}-${variantResult.pos}-${variantResult.ref}-${
        variantResult.alt
      }?dataset=${dataSet}`;
    }
  }

  return (
    <span className="varsome-right">
      <small className="tw-mr-4">
        <i className="varsome-icons icon-info" data-tooltip={dataTipText} />
        {exacUrl && (
          <a data-testid="exacUrl" href={getVarsoUrl(exacUrl)} target="_blank">
            {` View this on gnomAD Browser`}
          </a>
        )}
      </small>
    </span>
  );
};
GnomadUrl.displayName = "GnomadUrl";

GnomadUrl.propTypes = {
  variantResult: PropTypes.shape({
    pos: PropTypes.number,
    alt: PropTypes.string,
    ref: PropTypes.string,
    chromosome: PropTypes.string,
    gnomad_exomes: PropTypes.arrayOf(
      PropTypes.shape({ original_variant: PropTypes.string })
    ),
    gnomad_genomes: PropTypes.arrayOf(
      PropTypes.shape({ original_variant: PropTypes.string })
    ),
  }).isRequired,
  gnomadType: PropTypes.string.isRequired,
  refGenome: PropTypes.string,
  version: PropTypes.string,
};

GnomadUrl.defaultProps = {
  refGenome: null,
  version: "",
};

export default GnomadUrl;
